import { baseApi } from "../baseApi";
import { AttendanceSubmitRequest, AttendanceTodayResponse } from "./type";

export const attendanceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAttendanceToday: build.query<AttendanceTodayResponse, void>({
      query: () => ({
        url: "/attendance/today",
        method: "GET",
      }),
      providesTags: ["Attendance"],
    }),
    attendanceCheckIn: build.mutation<
      AttendanceTodayResponse,
      AttendanceSubmitRequest
    >({
      query: (body) => ({
        url: "/attendance/check-in",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Attendance"],
    }),
  }),
});

export const {
  useGetAttendanceTodayQuery,
  useAttendanceCheckInMutation,
} = attendanceApi;
